// Environment-specific origins. Set REACT_APP_API_URL / REACT_APP_PORTAL_URL at build time
// (see .env.qa and build-qa.sh); defaults point at production.
export const API_ORIGIN = process.env.REACT_APP_API_URL || 'https://api.festivalsportal.mt';
export const PORTAL_ORIGIN = process.env.REACT_APP_PORTAL_URL || 'https://portal.festivalsportal.mt';

console.log(API_ORIGIN === 'https://api.festivalsportal.mt' ? 'PROD' : 'QA');
